import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'react-magma-dom';
import { DownloadIcon } from 'react-magma-icons';


const DonwloadTrigger = ({ onOpenModal }) => (
  <IconButton
    style={{ fontSize: 14 }}
    isFullWidth
    aria-label="Download" icon={<DownloadIcon />}
    onClick={onOpenModal}
  >
    Download Dataset
  </IconButton>
);

DonwloadTrigger.propTypes = {
  onOpenModal: PropTypes.func.isRequired
};

export default DonwloadTrigger;
